export default "__VITE_ASSET__BRFezbzW__"